import request from 'superagent';
import moment from 'moment';

import React from 'react'
import ReactDOM from 'react-dom';

window.React = React;

let location = null
let fromStorage = localStorage.getItem('location')
if (fromStorage) {
	location = JSON.parse(fromStorage)
}

let comparisons = {
	cloudCover: (t, y) => {
		if (t.cloudCover < 0.1 && y.cloudCover < 0.1) {
			return '' // when it's not cloudy, don't talk about clouds
		}
		let delta = percentDiff(t.cloudCover, y.cloudCover)
		let cloudiness = delta > 0 ? 'cloudier' : 'less cloudy';
		return `${modifier(delta)} ${cloudiness}`
	},
	temperature: (t, y) => {
		let delta = absoluteDiff(t.temperature, y.temperature);
		let grade = Math.abs(delta);
		let temp = (delta > 0) ? 'warmer' : 'colder';
		if (grade < 2) {
			return `about the same temperature`
		}
		return `${modifier(grade)} ${temp}`;
	},
	precipProbability: (t, y) => {
		if (t.precipProbability < 0.1 && y.precipProbability < 0.1) {
			return '' // when it's not rainy, don't talk about rain
		}
		let delta = percentDiff(t.precipProbability, y.precipProbability)
		let precip = delta > 0 ? 'rainier' : 'less rainy';
		return `${modifier(delta)} ${precip}`
	},
	humidity: (t, y) => {
		let delta = percentDiff(t.humidity, y.humidity);
		if (Math.abs(delta) < 5) {
			return ''
		}
		let humidity = delta > 0 ? 'more humid' : 'less humid';
		return `${modifier(delta)} ${humidity}`
	},
	windSpeed: (t, y) => {
		if (t.windSpeed < 10 && y.windSpeed < 10) {
			return '' // when it's not windy, don't talk about wind
		}
		let delta = absoluteDiff(t.windSpeed, y.windSpeed);
		let windiness = delta > 0 ? 'windier' : 'less windy';
		return `${modifier(delta)} ${windiness}`
	}
}

function absoluteDiff() {
	return Array.prototype.slice.call(arguments).reduce( (x1, x2) => ((x1 - x2)/x1) * 100 )
}

function percentDiff() {
	return Array.prototype.slice.call(arguments).reduce( (x2, x1) => (x2 - x1) * 100 )
}

function modifier(n) {
	n = Math.abs(n)
	if (n > 15) {
		return 'a lot'
	} else if (n > 10 && n < 15) {
		return 'much'
	} else if (n > 5 && n < 10) {
		return 'somewhat'
	}
	return 'a bit'
}

function timeOfDay(m) {
	let hour = m.hour()
	if(hour >= 12 && hour <= 17) {
		return 'afternoon'
	} else if(hour >= 17) {
		return 'evening'
	} else {
		return 'morning'
	}
}

function fetch(time = '') {
	if (time) {
		time = ',' + time
	}
	return request
		.get(`https://bigboy.us/forecast/${location.coords[1]},${location.coords[0]}${time}?exclude=flags`)
		.then(data =>  data.body.currently)
}

function geocode(place = '') {
	return request
		.get(`https://search.mapzen.com/v1/search?text=${place}&api_key=mapzen-Vwfq5Xx&size=1`)
		.then(data => data.body.features.map( f => {
			return { coords: f.geometry.coordinates, place: f.properties.label }
		}))
		.then(data => data.reduce( first => first ))
}

function relativeFetch(t, y) {
	return Promise.all([t, y])
		.then( days => {
			return Object.keys(comparisons)
				.map( key => comparisons[key](days[0], days[1]) )
				.filter( val => val.length )
		})
}

let yesterday = moment().subtract(1, 'days')
let tomorrow = moment().add(1, 'days')
let todaysDate = timeOfDay(moment())

import conditions from './conditions.jsx'

window.addEventListener('load', render)

function setLocation(l) {
	geocode(l)
		.then( loc => {
			location = loc
			localStorage.setItem('location', JSON.stringify(location))
		})
		.then(render)
}

function render() {
	if (!location) {
		ReactDOM.render(React.createElement(conditions, {
			todaysDate: todaysDate,
			onSetLocation: setLocation
		}), document.getElementById('conditions'));
		return
	}
	let todayFetch = fetch(),
		tomorrowFetch = fetch(tomorrow.unix()),
		yesterdayFetch = fetch(yesterday.unix());
	Promise.all([
		relativeFetch(todayFetch, yesterdayFetch),
		relativeFetch(tomorrowFetch, todayFetch)
	]).then( res => {
		let [today, tomorrow] = res
		ReactDOM.render(React.createElement(conditions, {
			todaysDate: todaysDate,
			locationText: location.place,
			onSetLocation: setLocation,
			today: today,
			tomorrow: tomorrow
		}), document.getElementById('conditions'));
	})
}

// cloudCover e.g. 0.6
// temperature e.g. 56.29
// precipProbability e.g. 0.48
// humidity e.g. 0.76
// windSpeed e.g. 15.54


/** WEBPACK FOOTER **
 ** ./index.js
 **/